import type { CategoryResponseDto } from "@/types/category.dto";
import type { AdminCategory } from "@/types/category";

export function mapCategoryResponseToAdmin(dto: CategoryResponseDto): AdminCategory {
  return {
    id: String(dto.id),
    name: dto.name,
    slug: dto.slug,
    parentId: dto.parentCategoryId != null ? String(dto.parentCategoryId) : null,
    imageUrl: dto.imageUrl,
    description: dto.description,
    displayOrder: dto.displayOrder,
    isActive: dto.isActive,
    productCount: dto.productCount,
    commissionPercentage: dto.commissionPercentage,
  };
}

export function mapCategoryResponsesToAdmin(items: CategoryResponseDto[]): AdminCategory[] {
  return items.map(mapCategoryResponseToAdmin);
}
